import { format, parseISO } from 'date-fns';
import * as R from 'ramda';
import { formatDateForExport } from 'utils/helpers/format';

const minWidth = 150;

const BookingHistoryColumns = [
  {
    cellClassName: 'css-heap-redact',
    field: 'productShortName',
    headerName: 'Product',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'productIdName',
    headerName: 'Product ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'availableVol',
    headerName: 'Available Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inTransitVol',
    headerName: 'In Transit Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'availableReservedVol',
    headerName: 'Available Reserved Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inTransitReservedVol',
    headerName: 'In Transit Reserved Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'sitVol',
    headerName: 'SIT Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'totalVol',
    headerName: 'Total Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    field: 'locationShortName',
    headerName: 'Location',
    minWidth,
  },
  {
    field: 'locationIdName',
    headerName: 'Location ID',
    minWidth,
  },
  {
    field: 'referenceId',
    headerName: 'Reference ID',
    minWidth,
    renderCell: ({ row }) => (R.prop('referenceId', row) ? R.prop('referenceId', row) : null), // remove commas from numbers
    type: 'number',
  },
  {
    field: 'transactionType',
    headerName: 'Transaction Type',
    minWidth,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth,
  },
  {
    field: 'originShortName',
    headerName: 'Origin',
    minWidth,
  },
  {
    field: 'originIdName',
    headerName: 'Origin ID',
    minWidth,
  },
  {
    field: 'transactionDate',
    headerName: 'Transaction Date (CST)',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('transactionDate', row)
        ? format(parseISO(R.prop('transactionDate', row)), 'MM/dd/yyyy HH:mm:ss')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'shipmentId',
    headerName: 'Shipment Request ID',
    minWidth,
    renderCell: ({ row }) => (R.prop('shipmentId', row) ? R.prop('shipmentId', row) : null), // remove commas from numbers
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerShortName',
    headerName: 'Inventory Owner',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerIdName',
    headerName: 'Inventory Owner ID',
    minWidth,
  },
  {
    field: 'rvp',
    headerName: 'RVP',
    minWidth,
    type: 'number',
  },
  {
    field: 'prodDesignRvp',
    headerName: 'Prod Desig RVP',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'shipperShortName',
    headerName: 'Shipper',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'shipperIdName',
    headerName: 'Shipper ID',
    minWidth,
    type: 'number',
  },
  {
    field: 'purchaseOrderNumber',
    headerName: 'Purchase Order Number',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('purchaseOrderNumber', row) ? R.prop('purchaseOrderNumber', row) : null, // remove commas from numbers
    type: 'number',
  },
  {
    field: 'bookedDate',
    headerName: 'Booked Date (CST)',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('bookedDate', row)
        ? format(parseISO(R.prop('bookedDate', row)), 'MM/dd/yyyy HH:mm:ss')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'businessBookedDate',
    headerName: 'Business Booked Date (CST)',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('businessBookedDate', row)
        ? format(parseISO(R.prop('businessBookedDate', row)), 'MM/dd/yyyy HH:mm:ss')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'appliedDate',
    headerName: 'Applied Date',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('appliedDate', row)
        ? format(parseISO(R.prop('appliedDate', row)), 'MM/dd/yyyy HH:mm:ss')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'shipmentClosedDate',
    headerName: 'Shipment Close Date',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('shipmentClosedDate', row)
        ? format(parseISO(R.prop('shipmentClosedDate', row)), 'MM/dd/yyyy')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'rateEffDate',
    headerName: 'Rate Eff. Date',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('rateEffDate', row)
        ? format(parseISO(R.prop('rateEffDate', row)), 'MM/dd/yyyy')
        : null,
    valueFormatter: formatDateForExport('MM/d/yyyy HH:mm:ss'),
  },
  {
    field: 'verificationNum',
    headerName: 'Verification Num.',
    minWidth,
    renderCell: ({ row }) =>
      R.prop('verificationNum', row) ? R.prop('verificationNum', row) : null, // remove commas from numbers
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'prodDesignFuelType',
    headerName: 'Prod Desig Fuel Type',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'prodDesignOxygenate',
    headerName: 'Prod Desig Oxygenate',
    minWidth,
  },
  {
    field: 'impactsSit',
    headerName: 'Impacts SIT',
    minWidth,
  },
  {
    field: 'ton',
    headerName: 'Ton',
    minWidth,
  },
];

export default BookingHistoryColumns;
